import type { Workflow } from "../types";

export function WorkflowStatusBadges({ workflow }: { workflow: Workflow }) {
  return (
    <div className="flex flex-wrap gap-2">
      <span
        className={`rounded-full px-3 py-1 text-xs font-semibold ${
          workflow.active
            ? "bg-emerald-100 text-emerald-700"
            : "bg-slate-100 text-slate-500"
        }`}
      >
        {workflow.active ? "Active" : "Inactive"}
      </span>

      <span
        className={`rounded-full px-3 py-1 text-xs font-semibold ${
          workflow.published
            ? "bg-blue-100 text-blue-700"
            : "bg-amber-100 text-amber-700"
        }`}
      >
        {workflow.published ? "Published" : "Draft"}
      </span>

      {workflow.defaultWorkflow ? (
        <span className="rounded-full bg-purple-100 px-3 py-1 text-xs font-semibold text-purple-700">
          Default
        </span>
      ) : null}

      <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
        Version {workflow.versionNo ?? 1}
      </span>
    </div>
  );
}